import Vue from 'vue';
import VueKindergarten from 'vue-kindergarten';
import child from './child';
import axios from './plugins/axios';
import './plugins/vue-toasted';
import './plugins/vee-validate';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(VueKindergarten, {
  child
})

store.dispatch('authUser').then(() => {
  Vue.prototype.$eventBus = new Vue();
  Vue.prototype.$axios = axios;

  new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})

